module.exports = __webpack_public_path__ + "img/3d-export_jp.2b19787.jpg";